import ExploreModal from "./ExploreModal";
import { FiCalendar, FiUsers } from "react-icons/fi";

const EnvolvementThumbnail = (props) => {
  const endDate = new Date(props.data.endDate.endDate);
  const publishedDate = new Date(props.data.datePublished);
  var sAfterDays = "";
  function formatDate(string) {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  }
  function endDateCalculate(dateString) {
    const inputDate = new Date(dateString);
    const currentDate = new Date();
    const differenceInMilliseconds = inputDate - currentDate;
    const differenceInDays = Math.floor(
      differenceInMilliseconds / (1000 * 60 * 60 * 24)
    );
    return differenceInDays;
  }
  if (endDateCalculate(endDate) > 1) sAfterDays = "s";
  return (
    <ExploreModal props={props.data}>
      <div className="group relative bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer">
        {/* Image Container */}
        <div className="relative aspect-video overflow-hidden">
          <img
            src={props.data.imgUrl}
            className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
            alt={props.data.title}
          />

          {/* Price Badge */}
          <div className="absolute top-3 right-3 px-3 py-1 bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm text-gray-900 dark:text-white rounded-full text-sm font-medium">
            {props.data.price.free ? "Free" : `$${props.data.price.price}`}
          </div>
        </div>
        {/* Content Container */}
        <div className="p-4 space-y-3">
          {/* Title and Preview */}
          <div>
            <h3 className="text-lg font-bold text-gray-900 dark:text-white line-clamp-1">
              {props.data.title}
            </h3>
            <p className="mt-1 text-sm text-gray-600 dark:text-gray-300 line-clamp-2">
              {props.data.previewText}
            </p>
          </div>
          {/* Stats Container */}
          <div className="flex items-center justify-between pt-2 border-t border-gray-200 dark:border-gray-700">
            <div className="flex items-center space-x-2">
              <div className="flex items-center">
                <FiCalendar className="w-4 h-4 text-gray-500 dark:text-gray-400" />
                <span className="ml-1 text-sm font-medium text-gray-700 dark:text-gray-300">
                  {props.data.endDate.none
                    ? "No Deadline"
                    : `${endDateCalculate(endDate)} Day${sAfterDays} Left`}
                </span>
              </div>
            </div>
            <div className="flex items-center space-x-1 text-sm font-medium text-gray-700 dark:text-gray-300">
              <FiUsers className="w-4 h-4 text-gray-500 dark:text-gray-400" />
              <span className="ml-1">
                {props.data.quantity.unlimited
                  ? "Unlimited"
                  : `${
                      props.data.quantity.quantity -
                      props.data.quantity.currentEnvolves
                    }/${props.data.quantity.quantity}`}
              </span>
            </div>
          </div>
          {/* User Info */}
          <div className="flex items-center pt-3 border-t border-gray-200 dark:border-gray-700">
            <img
              src={props.data.userPicture}
              className="w-10 h-10 rounded-full object-cover ring-2 ring-primary-500"
              alt={props.data.username}
            />
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-900 dark:text-white truncate">
                {props.data.username}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                Posted {formatDate(publishedDate)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </ExploreModal>
  );
};

export default EnvolvementThumbnail;
